// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"439":"dcedf81d","927":"cbc6d1f8"}[chunkId] + ".css";
};